import React from 'react';
import ExcerciseApp from './excerciseForm'; 
import DisplayChart from './displayChart';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

function Excercise()  {
	return (
		<div style={{}}>
			<Card
				style={{
				width: 800,
				backgroundColor: "#ffffeh",
				}}
			>
				<CardContent>
					<h1> Excercise </h1>
					<div className="container">
						<div className="row align-items-center my-5">
							<ExcerciseApp/>
							<br />
						</div>
						<div className="table_container">
							<br />
							<DisplayChart />
						</div>
					</div>
				</CardContent>
				{/* <CardActions>
				<Button size="small">Stay Safe.....</Button>
				</CardActions> */}
			</Card>
		</div>
	)
}


export default Excercise  ; //new